import type { CSSProperties } from 'react';
import { twMerge } from 'tailwind-merge';
import { ORDER_STATUS_COLORS } from '@witmetrics/unison-core';
import { classes, styles } from './utils';

export type OrderStatusCircleProps = {
  className?: string;
  style?: CSSProperties;
  size?: number;
  orderStatusId: keyof typeof ORDER_STATUS_COLORS;
};

export default function OrderStatusCircle({
  className,
  style = {},
  size = 16,
  orderStatusId,
}: OrderStatusCircleProps) {
  return (
    <div
      style={{ ...styles.wrapper(size), ...style }}
      className={twMerge(
        classes.wrapper,
        ORDER_STATUS_COLORS[orderStatusId].bg,
        className
      )}
    />
  );
}
